import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, Users, UserCheck, Clock, Plus } from "lucide-react";
import { api, fmtTime, EVENT_LABEL } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { PageHeader, StatCard, StatusPill, Empty } from "../../components/common";

export default function EmployerHome() {
  const { user } = useAuth();
  const [jobs, setJobs] = useState([]);
  const [team, setTeam] = useState([]);

  useEffect(() => { Promise.all([api.get("/employer/jobs"), api.get("/employer/team")]).then(([j, t]) => { setJobs(j.data); setTeam(t.data); }); }, []);
  const onShift = team.filter((t) => t.attendance_state !== "off").length;

  return (
    <div>
      <PageHeader eyebrow={user.company_name} title="Employer dashboard" subtitle="Post jobs, review automatched candidates and manage your placed staff."
        action={<Link to="/app/employer/jobs?new=1" className="dx-btn-gold" data-testid="employer-post-job-btn"><Plus className="w-4 h-4" />Post a job</Link>} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard accent label="Open jobs" value={jobs.filter((j) => j.status === "open").length} icon={Briefcase} testid="stat-open-jobs" />
        <StatCard label="Applicants" value={jobs.reduce((s, j) => s + j.applications, 0)} icon={Users} testid="stat-applicants" />
        <StatCard label="Team" value={team.length} icon={UserCheck} testid="stat-team" />
        <StatCard label="On shift now" value={onShift} icon={Clock} testid="stat-on-shift" />
      </div>
      <div className="grid lg:grid-cols-2 gap-5 mt-6">
        <div className="dx-card p-6">
          <h3 className="font-display font-semibold text-lg mb-3">Your jobs</h3>
          {jobs.length === 0 ? <p className="text-sm text-[#6b5a73]">No jobs yet.</p> : jobs.slice(0, 6).map((j) => (
            <Link key={j.id} to={`/app/employer/jobs/${j.id}`} className="flex items-center justify-between py-3 border-b last:border-0 hover:text-[#5B2A6E]" data-testid={`employer-home-job-${j.id}`}>
              <div><div className="font-semibold">{j.title}</div><div className="text-xs text-[#6b5a73]">{j.location} · {j.applications} applicants</div></div>
              <StatusPill status={j.status} />
            </Link>
          ))}
        </div>
        <div className="dx-card p-6">
          <h3 className="font-display font-semibold text-lg mb-3">Team today</h3>
          {team.length === 0 ? <Empty icon={Users} title="No staff placed yet" text="Hire a candidate from a job pipeline and they will appear here." /> : team.map((t) => (
            <div key={t.staff_id} className="flex items-center justify-between py-3 border-b last:border-0" data-testid={`employer-home-team-${t.staff_id}`}>
              <div><div className="font-semibold">{t.staff_name}</div><div className="text-xs text-[#6b5a73]">{t.job_title}{t.last_event ? ` · ${EVENT_LABEL[t.last_event.type]} ${fmtTime(t.last_event.timestamp)}` : ""}</div></div>
              <StatusPill status={t.attendance_state} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
